import React, { useEffect, useRef } from 'react'
import './ourstory.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Ourstory = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 85%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        }).to(buttonRef.current, {
            rotateY: 360,
            duration: 0.8,
            ease: "power2.inOut",
        });
    }, []);


    return (
        <>
            <section className='ourstorymainprnt'>
                <div className="postionmiddlestory">
                    <img className='img-fluid' src="\assets\Aboutus\postionmiddlestory.png" alt="" />
                </div>
                <div className="custom-container">
                    <div className="ourstorychldprnt">
                        <div className="storyprnt">
                            <div className="rightimgprnt">
                                <img className='img-fluid' src="\assets\Aboutus\storyleftimg.png" alt="ourstoryimg" />
                            </div>
                            <div className="aboutusmission">
                                {/* <h5 ref={buttonRef}>Who We Are</h5> */}
                                <div className="aboutusmissioncnt">
                                    <h2 ref={textRef}>Our Story</h2>
                                    <p ref={paraRef}>At TOMI, we’re on a mission to democratize the internet and empower people to take ownership of their digital lives. Founded with the belief that true freedom means owning your identity, connections, and assets, we are creating a secure and decentralized space where everyone can thrive.</p>                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Ourstory